global.joiValidate = (rule, value) => {
  const result = rule.validate(value, {
    allowUnknown: true,
    stripUnknown: true,
  });
  if (result?.error) {
    // const originalValue = result?.error?.details?.[0]?.context?.value;
    const errorMessage = result?.error?.message?.replace(/"/g, '');
    throw new Error(`${errorMessage}`);
  }
  return result.value;
};

global.setStateJSON = (setStateVariable, key, value) => {
  setStateVariable((prevState) => {
    // Create a new state object by spreading the previous state
    // and updating the value associated with the specified key
    return { ...prevState, [key]: value };
  });
};

global.joi_string = (value) => {
  if (value === null || value === undefined) {
    return '';
  }
  return value;
};

global.joi_default_false = (value) => {
  if (value === null || value === undefined) {
    return false;
  }
  return value;
};
